// extracted by mini-css-extract-plugin
module.exports = {"description":"style_description__3D-eq"};